// Tailwind injection
import './tailwind.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider, ScrollRestoration } from 'react-router-dom';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import { AppProvider } from './context/app-context';
import { ApplicationInsightsContext } from './context/ApplicationInsights.context';
import { LocalizationProvider } from './context/localization-context';
import { TanstackQueryClientProvider } from './lib/query/tanStackQueryProvider';

// Root component rendered inside the data router — has access to router context.
// ScrollRestoration must live here so it can interact with the router's scroll state.
function Root() {
  return (
    <>
      <ScrollRestoration
        getKey={(location) => {
          return location.pathname; // Persist scroll on query changes
        }}
      />
      <ApplicationInsightsContext>
        <TanstackQueryClientProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </TanstackQueryClientProvider>
      </ApplicationInsightsContext>
    </>
  );
}

const router = createBrowserRouter([
  {
    path: '*',
    element: <Root />,
  },
]);

const container = document.getElementById('root');
if (container !== null) {
  const root = createRoot(container);

  root.render(
    <AppProvider>
      <StrictMode>
        <LocalizationProvider>
          <RouterProvider router={router} />
        </LocalizationProvider>
      </StrictMode>
    </AppProvider>
  );
}
